import { useLocation, useSearch } from 'wouter';

/**
 * Parses the active wouter location for a v2 conversation `shortId` so the
 * app-root `<ConversationProvider>` can key off it.
 *
 * Path-segment matches (existing):
 *   /projects/:shortId/overview|research|participants|interviews|meetings|insights|recommendations|chat|bet|scoping
 *   /projects/:shortId/overview/...
 *   /conversation/:shortId
 *   /conversation/:shortId/...
 *
 * Query-param match (Phase 7):
 *   /?project=<shortId>
 *
 * Path-segment matches take precedence — `?project=` is a home-page-only
 * convention and is ignored on other routes.
 *
 * Returns null for non-matching routes (homepage without `?project=`,
 * settings, v1 routes).
 */
export function useShortIdFromLocation(): string | null {
  const [path] = useLocation();
  const search = useSearch();

  /** Project dashboard tabs + the V2 scoping call — keep slug aligned across Overview / Plan / scoping so lifecycle + surfaceKey stay stable. */
  const projectDashboardMatch = path.match(
    /^\/projects\/([^/]+)\/(overview|research|participants|interviews|meetings|insights|recommendations|chat|bet|scoping)(?:\/|$)/,
  );
  if (projectDashboardMatch) return projectDashboardMatch[1];

  const conversationMatch = path.match(/^\/conversation\/([^/]+)(?:\/|$)/);
  if (conversationMatch) return conversationMatch[1];

  if (path === '/' || path === '') {
    const params = new URLSearchParams(search);
    const projectParam = params.get('project');
    if (projectParam && projectParam.length > 0) return projectParam;
  }

  return null;
}
